import React, { useContext, useEffect } from 'react';
import {
    generateSaveFile,
    RydProject
} from '../../model/project';


export function RydSaveProjectDialog({ line }: { line: RydProject }) {

    const generateAndSaveDialog = () => {
        const { lineJSON, saveFileName } = generateSaveFile(line);

        var tempLink = document.createElement("a");
        var taBlob = new Blob([lineJSON], { type: 'text/plain' });

        tempLink.setAttribute('href', URL.createObjectURL(taBlob));
        tempLink.setAttribute('download', saveFileName);
        tempLink.click();

        URL.revokeObjectURL(tempLink.href);
    };

    return (<button onClick={generateAndSaveDialog} >Save</button>);
}
